const getTransactionStatus = (transaction) => {
  if (transaction.canceled) return 'annulled';
  if (transaction.refundId) return 'refund';
  if (transaction.status === 'reverted') return 'reverted';
  return 'closed';
};

export default getTransactionStatus
